import ChartContainer from './ChartContainer';

export default ChartContainer;
